import { render, staticRenderFns } from "./ButtonPillsNavigation.vue?vue&type=template&id=3994bc22"
import script from "./ButtonPillsNavigation.vue?vue&type=script&lang=js"
export * from "./ButtonPillsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports